module.exports = __webpack_public_path__ + "static/ux-884babcfc54993e150a1d9b8b5b8ca4c.png";